import STORE_RESOURCE_DETAILS from '../types/resourceDetails';


const storeResourceDetails = (resource, resourceDetails) => ({
  type: `${STORE_RESOURCE_DETAILS}_${resource}`,
  payload: resourceDetails,
});

export default storeResourceDetails;
